import { useEffect, useMemo, useState } from 'react';

export type UseObjectUrlProps = { blob?: Blob | null };

/**
 * Creates an object URL based on a blob.
 *
 * Handles creating new object URLs when blob changes, and revoking old object
 * URLs when blob changes and on unmount to prevent memory leaks.
 */
export const useObjectUrl = ({ blob }: UseObjectUrlProps) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    const revokeOldObjectUrl = () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };

    // Revoke existing object URL before setting a new one to prevent memory
    // leak.
    revokeOldObjectUrl();

    const newThumbnailUrl = blob ? URL.createObjectURL(blob) : null;

    setObjectUrl(newThumbnailUrl);

    // Revoke existing object URL on unmount to prevent memory leak.
    return revokeOldObjectUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blob]);

  const returnValue = useMemo(
    () => ({
      objectUrl,
    }),
    [objectUrl],
  );

  return returnValue;
};
